import Link from "next/link";

import { slugifyProject } from "../../utils/common";
import CreatedBy from "../CreatedBy";
import { UserFormatableTextOnlyDisplay } from "../form-fields/UserFormatableText";

const BlogListItem = ({ blog, maxLines = 5 }) => (
  <div className="box">
    <h2 className="subtitle">
      <Link href={`/blogs/${slugifyProject(blog)}`}>{blog.title}</Link>
    </h2>

    <CreatedBy
      className="block"
      user={blog.created_by_user}
      createdAt={blog.created_at}
    />

    <UserFormatableTextOnlyDisplay value={blog.body} maxLines={maxLines} />
  </div>
);

export default BlogListItem;
